import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, useCallback, useContext, useState } from 'react';
const ZeroCodonationContext = createContext({
  shown: false,
  show: () => {}
});
export function useZeroCodonationMessageContext() {
  return useContext(ZeroCodonationContext);
}
export function ZeroCodonationMessageContextProvider(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [shown, setShown] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShown(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const show = t1;
  let t2;
  if ($[1] !== shown) {
    t2 = {
      shown,
      show
    };
    $[1] = shown;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <ZeroCodonationContext.Provider value={t2}>{children}</ZeroCodonationContext.Provider>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}